// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"template"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 21L21 9L3 9L3 21H10L21 21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3L3 3L3 9H10L21 9V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 9V21H10M21 9H3M21 9V3H3V9M21 9H10M3 9V21H10M3 9H10M10 21V9","strokeWidth":"props.strokeWidth"}}]}]};

const TemplateIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'template',
    ref,
    icon: element,
  },
));

TemplateIcon.displayName = 'TemplateIcon';

export default TemplateIcon;
